import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import DateInput from "components/Input/DateInput.js";
import IntInput from "components/Input/IntInput.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import UserService from "services/UserService";
import { makeStyles } from "@mui/styles";
import { getSite } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { declapage } from "variables/tertiaryBill";
import { NotificationManager } from 'react-notifications';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));


export default function TertiaryBill(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [tertiarybill, setTertiarybill] = useState("");
  const [intertiarybill, setIntertiarybill] = useState(false);
  const [consoindi, setconsoindi] = useState(true);
  const [consorep, setconsorep] = useState(false);
  const [consocom, setconsocom] = useState(false);
  const [consoelec, setconsoelec] = useState(false);
  const [consogaznatreseau, setconsogaznatreseau] = useState(false);
  const [consogaznatliq, setconsogaznatliq] = useState(false);
  const [consogazprop, setconsogazprop] = useState(false);
  const [consogazbut, setconsogazbut] = useState(false);
  const [consofiouldom, setconsofiouldom] = useState(false);
  const [consocharbonagglo, setconsocharbonagglo] = useState(false);
  const [consohouille, setconsohouille] = useState(false);
  const [consoboisplaqind, setconsoboisplaqind] = useState(false);
  const [consoboisplaqfor, setconsoboisplaqfor] = useState(false);
  const [consoboisgran, setconsoboisgran] = useState(false);
  const [consoboisbuche, setconsoboisbuche] = useState(false);
  const [consoreseauchal, setconsoreseauchal] = useState(false);
  const [consoreseaufrois, setconsoreseaufrois] = useState(false);


  const handleIntertiarybillChange = (event) => { setIntertiarybill(!intertiarybill); };
  const handleconsoindiChange = (event) => { setconsoindi(!consoindi); };
  const handleconsorepChange = (event) => { setconsorep(!consorep); };
  const handleconsocomChange = (event) => { setconsocom(!consocom); };
  const handleconsoelecChange = (event) => { setconsoelec(!consoelec); };
  const handleconsogaznatreseauChange = (event) => { setconsogaznatreseau(!consogaznatreseau); };
  const handleconsogaznatliqChange = (event) => { setconsogaznatliq(!consogaznatliq); };
  const handleconsogazpropChange = (event) => { setconsogazprop(!consogazprop); };
  const handleconsogazbutChange = (event) => { setconsogazbut(!consogazbut); };
  const handleconsofiouldomChange = (event) => { setconsofiouldom(!consofiouldom); };
  const handleconsocharbonaggloChange = (event) => { setconsocharbonagglo(!consocharbonagglo); };
  const handleconsohouilleChange = (event) => { setconsohouille(!consohouille); };
  const handleconsoboisplaqindChange = (event) => { setconsoboisplaqind(!consoboisplaqind); };
  const handleconsoboisplaqforChange = (event) => { setconsoboisplaqfor(!consoboisplaqfor); };
  const handleconsoboisgranChange = (event) => { setconsoboisgran(!consoboisgran); };
  const handleconsoboisbucheChange = (event) => { setconsoboisbuche(!consoboisbuche); };
  const handleconsoreseauchalChange = (event) => { setconsoreseauchal(!consoreseauchal); };
  const handleconsoreseaufroisChange = (event) => { setconsoreseaufrois(!consoreseaufrois); };


  const handleEdit = async (event) => {
    axios
      .put(
        getSite(chartIdGroup, "tertiarybill"),
        {
          ...tertiarybill,
          intertiarybill,
          consoindi,
          consorep,
          consocom,
          consoelec,
          consogaznatreseau,
          consogaznatliq,
          consogazprop,
          consogazbut,
          consofiouldom,
          consocharbonagglo,
          consohouille,
          consoboisplaqind,
          consoboisplaqfor,
          consoboisgran,
          consoboisbuche,
          consoreseauchal,
          consoreseaufrois,

        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "tertiarybill"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setTertiarybill(res.data.detail.tertiarybill || {});
        setIntertiarybill(res.data.detail.tertiarybill?.intertiarybill);
        // setconsoindi(res.data.detail.tertiarybill?.consoindi);
        setconsorep(res.data.detail.tertiarybill?.consorep);
        setconsocom(res.data.detail.tertiarybill?.consocom);
        setconsoelec(res.data.detail.tertiarybill?.consoelec);
        setconsogaznatreseau(res.data.detail.tertiarybill?.consogaznatreseau);
        setconsogaznatliq(res.data.detail.tertiarybill?.consogaznatliq);
        setconsogazprop(res.data.detail.tertiarybill?.consogazprop);
        setconsogazbut(res.data.detail.tertiarybill?.consogazbut);
        setconsofiouldom(res.data.detail.tertiarybill?.consofiouldom);
        setconsocharbonagglo(res.data.detail.tertiarybill?.consocharbonagglo);
        setconsohouille(res.data.detail.tertiarybill?.consohouille);
        setconsoboisplaqind(res.data.detail.tertiarybill?.consoboisplaqind);
        setconsoboisplaqfor(res.data.detail.tertiarybill?.consoboisplaqfor);
        setconsoboisgran(res.data.detail.tertiarybill?.consoboisgran);
        setconsoboisbuche(res.data.detail.tertiarybill?.consoboisbuche);
        setconsoreseauchal(res.data.detail.tertiarybill?.consoreseauchal);
        setconsoreseaufrois(res.data.detail.tertiarybill?.consoreseaufrois);
      });
  }, []);

  const classes = useStyles();

  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ margin: "1.3rem 0rem" }}>
            <div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.intertiarybill} checkedState={intertiarybill} handleSwitchChange={handleIntertiarybillChange} /></div>
          </div>
        </GridItem>
        {intertiarybill ? (
          <>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={true} inputTitle={declapage.consoindi} checkedState={consoindi} handleSwitchChange={handleconsoindiChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consorep} checkedState={consorep} handleSwitchChange={handleconsorepChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consocom} checkedState={consocom} handleSwitchChange={handleconsocomChange} /></div></GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consoelec} checkedState={consoelec} handleSwitchChange={handleconsoelecChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consogaznatreseau} checkedState={consogaznatreseau} handleSwitchChange={handleconsogaznatreseauChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consogaznatliq} checkedState={consogaznatliq} handleSwitchChange={handleconsogaznatliqChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consogazprop} checkedState={consogazprop} handleSwitchChange={handleconsogazpropChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consogazbut} checkedState={consogazbut} handleSwitchChange={handleconsogazbutChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consofiouldom} checkedState={consofiouldom} handleSwitchChange={handleconsofiouldomChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consocharbonagglo} checkedState={consocharbonagglo} handleSwitchChange={handleconsocharbonaggloChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consohouille} checkedState={consohouille} handleSwitchChange={handleconsohouilleChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consoboisplaqind} checkedState={consoboisplaqind} handleSwitchChange={handleconsoboisplaqindChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consoboisplaqfor} checkedState={consoboisplaqfor} handleSwitchChange={handleconsoboisplaqforChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consoboisgran} checkedState={consoboisgran} handleSwitchChange={handleconsoboisgranChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consoboisbuche} checkedState={consoboisbuche} handleSwitchChange={handleconsoboisbucheChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consoreseauchal} checkedState={consoreseauchal} handleSwitchChange={handleconsoreseauchalChange} /></div></GridItem>
              <GridItem xs={12} sm={12} md={6}><div><CustomSwitch disabled={!realestateupdate} inputTitle={declapage.consoreseaufrois} checkedState={consoreseaufrois} handleSwitchChange={handleconsoreseaufroisChange} /></div></GridItem>
            </GridContainer>
          </>
        ) : (<></>)}


        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}
